import req from './http.js'

// 取得登入異常通知規則
export const apiGetThreshold = (org_id, container_id) => req('get', `/container/threshold?id=${container_id}&org=${org_id}`).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 更新登入異常通知規則
export const apiUpdateThreshold = (org_id, container_id, params) => req('patch', `/container/threshold?org=${org_id}&id=${container_id}`, params).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 新增登入異常通知規則
export const apiCreateThreshold = (org_id, params) => req('post', `/container/threshold?org=${org_id}`, params).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 取得登入紀錄
export const apiGetLoginRecord = (org_id, container_id) => req(
    'get', 
    `/container/detect/login?container_id=${container_id}&org=${org_id}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiGetContainerToken = (org_id, container_id) => req(
    'get', 
    `/container/secret/token?org=${org_id}&container_id=${container_id}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 新增token
export const apiCreateContainerToken = (org_id, params) => req(
    'post', 
    `/container/secret/token?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiUpdateContainerToken = (org_id, params) => req(
    'patch', 
    `/container/secret/token?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiDeleteContainerToken = (org_id, id) => req(
    'delete', 
    `/container/secret/token?org=${org_id}&id=${id}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 賦予權限給使用者
// export const apiAssignAuthToUser = (org_id) => req('put', '/admin/auth/assignAuthToUser?org=', org_id)


